var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmaXpsStdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5414 14.9609L24.2256 4.50893C22.9812 2.73438 21.0001 1.78571 18.9912 1.78571C17.73 1.78571 16.4521 2.1596 15.3361 2.94085C14.2367 3.71094 13.4555 4.77121 13.0202 5.94308C12.8584 2.63393 10.1519 0 6.80371 0C3.34947 0 0.553711 2.79576 0.553711 6.25V18.75C0.553711 22.2042 3.34947 25 6.80371 25C10.258 25 13.0537 22.2042 13.0537 18.75V10.4297C13.2379 10.9096 13.4611 11.3839 13.768 11.8248L21.0894 22.2768C22.3283 24.0513 24.3093 25 26.3238 25C27.5905 25 28.8629 24.6261 29.9789 23.8449C32.864 21.8248 33.5615 17.846 31.5414 14.9609ZM9.48228 12.5H4.12514V6.25C4.12514 4.77121 5.32492 3.57143 6.80371 3.57143C8.28251 3.57143 9.48228 4.77121 9.48228 6.25V12.5ZM20.3528 15.0056L16.6921 9.77679C16.2624 9.16295 16.095 8.41518 16.2289 7.67857C16.3573 6.94196 16.7702 6.29464 17.3841 5.86496C17.8584 5.53013 18.4164 5.35714 18.9912 5.35714C19.912 5.35714 20.7713 5.80357 21.2959 6.55692L24.9566 11.7857L20.3528 15.0056Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaXpsStdIcon);
export default __webpack_public_path__ + "static/media/pharma_xps_std_icon.93a0fc7c5582ed4219b6919eb93edadb.svg";
export { ForwardRef as ReactComponent };